import { render, staticRenderFns } from "./ondemand.vue?vue&type=template&id=586bce41&scoped=true&"
import script from "./ondemand.vue?vue&type=script&lang=js&"
export * from "./ondemand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586bce41",
  null
  
)

export default component.exports